import Vue from 'vue'

Vue.config.productionTip = false

const app = new Vue({
  el: '#app'
})

export default app
